import React from 'react';

const PageTitle = ({ title }) => (
    <>
        <h1 className="section-title">{title}</h1>
        <hr className="section-divider" />
    </>
);

export default PageTitle;
